/* istanbul ignore file */
export const ERROR_REFRESH_TOKEN_MISSING = 'error_refresh_token_missing';
export const ERROR_TIMED_OUT = 'error_timed_out';
export const ERROR_LOGIN_REQUIRED = 'error_login_required';
export const ERROR_DISALLOWED_ORIGIN = 'error_disallowed_origin';
export const ERROR_INVALID_SOURCE_URL = 'error_invalid_source_url';
export const ERROR_INVALID_REDIRECT_URI = 'error_invalid_redirect_uri';
export const ERROR_ID_TOKEN_NOT_PROVIDED = 'error_id_token_not_provided';
export const ERROR_CALLED_REFRESH_FOR_NOT_LOGGEDIN_USER =
  'error_called_refresh_for_not_loggedin_user';
export class AuthError extends Error {}
